import { DD } from "./constants";
import { computeKwScore } from "./utils";
import type { Post, Keyword } from "@shared/schema";

export function StatsBar({ posts, keywords }: { posts: Post[]; keywords: Keyword[] }) {
  const pub = posts.filter(p => p.status === "published").length;
  const sched = posts.filter(p => p.status === "scheduled").length;
  const rev = posts.filter(p => p.approvalStatus === "pending").length;
  const draft = posts.filter(p => p.status === "draft").length;
  const postsWithBody = posts.filter(p => p.content);
  const avgScore = postsWithBody.length > 0
    ? Math.round(postsWithBody.reduce((a, p) => a + computeKwScore(p.content, keywords), 0) / postsWithBody.length)
    : 0;

  const stats = [
    { n: pub, label: "Published", color: DD.green },
    { n: sched, label: "Scheduled", color: DD.indigo },
    { n: rev, label: "In Review", color: DD.warning },
    { n: draft, label: "Drafts", color: "#64748b" },
    { n: `${avgScore}%`, label: "Avg KW Score", color: avgScore >= 60 ? DD.green : DD.accent },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-4" data-testid="stats-bar">
      {stats.map((s, i) => (
        <div key={i} className="rounded-xl p-3 text-center" style={{ background: DD.surface, border: `1px solid ${DD.border}` }}>
          <div className="text-xl font-bold" style={{ color: s.color, fontFamily: "'JetBrains Mono', monospace" }} data-testid={`stat-${s.label.toLowerCase().replace(/ /g, "-")}`}>{s.n}</div>
          <div className="text-[10px] uppercase tracking-wider mt-0.5" style={{ color: DD.textTertiary }}>{s.label}</div>
        </div>
      ))}
    </div>
  );
}
